import { ApiService } from '../../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { EntityDomainDto } from 'src/app/affcode/shared/dto/entity-domain.dto';

@Injectable({
  providedIn: 'root',
})
export class EntityDomainService {
  constructor(private _apiService: ApiService) {}

  getEntityDomain(entityDomainId: number) {
    return this._apiService.get(`EntityDomain/${entityDomainId}`);
  }

  getAllDomainSettingBatches() {
    return this._apiService.get('EntityDomain/SettingBatches');
  }

  getSettingBatchForDomain(domain: string): Promise<Map<string, string>[]> {
    return this._apiService.get(`EntityDomain/SettingBatchForDomain?domain=${encodeURIComponent(domain)}`);
  }

  getAllEntityDomains(forceRefresh?: boolean): Promise<Array<EntityDomainDto>> {
    if (forceRefresh) {
      const cacheOpts = this._apiService.getDefaultApiCacheOptionsForNoCache();
      return this._apiService.get('EntityDomains', cacheOpts);
    } else {
      return this._apiService.get('EntityDomains');
    }
  }

  createEntityDomain(entityDomainDto: EntityDomainDto): Promise<number> {
    return this._apiService.post('EntityDomain', entityDomainDto);
  }

  updateEntityDomain(entityDomainDto: EntityDomainDto): Promise<number> {
    return this._apiService.put(`EntityDomain/${entityDomainDto.EntityDomainID}`, entityDomainDto);
  }

  deleteEntityDomain(id: number): Promise<number> {
    return this._apiService.delete(`EntityDomain/${id}`);
  }
}
